import { IconButton, type IconButtonProps } from '@pets-ui/IconButton/IconButton'
import { Search } from '@pets-ui/icons'
import { colors } from '@pets-ui/tokens/colors.stylex'

interface AppBarSearchProps extends IconButtonProps {
  onClick: () => void
}

export const AppBarSearch = (props: AppBarSearchProps) => {
  return (
    <IconButton width="32px" height="32px" {...props}>
      <Search fontSize={20} color={colors.grey900} />
    </IconButton>
  )
}
